import { BundleId } from '@mecontrol/common';
import { Promise } from '../promise';

export interface BundleMetadata {
    /** The bundle id for this metadata object */
    id: BundleId;

    /**
     * The cached promise created when the bundle script begins downloading.
     * Resolves to the result of the exports promise.
     */
    bundlePromise: Promise<any>;

    /**
     * The cached promise created when the bundle dependencies are downloading.
     * Resolves to the exports of the bundle.
     */
    exports?: Promise<any>;
}

export type BundleCache = { [bundleId in BundleId]?: BundleMetadata | undefined; };

const bundleCache: BundleCache = {};

export function getBundleCache(id: BundleId): BundleMetadata {
    return bundleCache[id] as any;
}

export function setBundleCache(id: BundleId, bundlePromise: Promise<any>, exports?: Promise<any>): void {
    bundleCache[id] = {
        id,
        bundlePromise,
        exports,
    };
}
